




























































































import Vue from 'vue';
import AirCalcResult from '@/classes/airCalcResult';
import { AIR_STATE } from '@/classes/const';

export default Vue.extend({
  name: 'AirStatusResultBar',
  props: {
    result: {
      type: AirCalcResult,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rate() {
      const r = this.result;
      return r.airState.value !== AIR_STATE.NONE ? Math.round(r.rates[r.airState.value]) : 0;
    },
    barWidth() {
      const r = this.result as AirCalcResult;
      return r.airState.value !== AIR_STATE.NONE ? r.airStateBarWidth : 0;
    },
    barColor() {
      const r = this.result as AirCalcResult;
      if (r.airState.value === AIR_STATE.NONE) {
        return 'secondary';
      }
      const value = r.airStateBarWidth;
      if (value >= 90) {
        return 'success';
      }
      if (value >= 45) {
        return 'light-green';
      }
      if (value >= 20) {
        return 'yellow';
      }
      if (value >= 10) {
        return 'orange';
      }
      return 'red';
    },
  },
});
